import { ChevronRight, Filter, SortAsc, Users } from 'lucide-react'
import * as React from 'react'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/shared/components/ui/collapsible'
import { ScrollArea } from '@/shared/components/ui/scroll-area'
import {
    Sidebar,
    SidebarContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/shared/components/ui/sidebar'
import { useCharactersStore } from '@/features/shared/stores/characters.store'

export default function ChOptionBar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { characters } = useCharactersStore()

    // Quick categories / filters
    const roles = Array.from(new Set(characters.map(c => c.role || 'Support')))

    return (
        <Sidebar
            collapsible="none"
            className="sticky top-0 hidden h-svh border-l lg:flex"
            side="right"
            {...props}
        >
            <SidebarContent>
                <div className="p-4 border-b">
                    <h2 className="text-sm font-semibold flex items-center gap-2">
                        <Users className="w-4 h-4" />
                        Character Stats
                    </h2>
                    <p className="text-xs text-muted-foreground mt-1">
                        Total Characters: {characters.length}
                    </p>
                </div>

                <Collapsible
                    defaultOpen={true}
                    className="group/collapsible flex flex-col pt-4"
                >
                    <SidebarGroupLabel
                        asChild
                        className="group/label text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground w-full text-sm px-4"
                    >
                        <CollapsibleTrigger>
                            Roles
                            <ChevronRight className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-90" />
                        </CollapsibleTrigger>
                    </SidebarGroupLabel>
                    <CollapsibleContent>
                        <SidebarMenu className="px-2">
                            {roles.map((role) => (
                                <SidebarMenuItem key={role}>
                                    <SidebarMenuButton size="sm">
                                        <Filter className="w-3.5 h-3.5 mr-2" />
                                        <span>{role}</span>
                                        <span className="ml-auto text-xs text-muted-foreground">
                                            {characters.filter(c => (c.role || 'Support') === role).length}
                                        </span>
                                    </SidebarMenuButton>
                                </SidebarMenuItem>
                            ))}
                        </SidebarMenu>
                    </CollapsibleContent>
                </Collapsible>
            </SidebarContent>
        </Sidebar>
    )
}
